import { render } from "./ThemeFooter.vue?vue&type=template&id=4efbb4a3"
import script from "./ThemeFooter.vue?vue&type=script&lang=js"
export * from "./ThemeFooter.vue?vue&type=script&lang=js"

import "./ThemeFooter.vue?vue&type=style&index=0&id=4efbb4a3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__